import React, { useState } from "react";
import { Box, Container, Table } from "@material-ui/core";
import { ButtonPlus, Header } from "../shared/Style/Style";
import { CustomTablePagination } from "../shared/CustomTablePagination";
import { PromoCode } from "./PromoCode";
import { PromoCodesModal } from "./PromoCodesModal";
import { PromoCodesHeaderRow, PromoCodesHeadTableCell } from "./PromoCodes.style";
import { useGetPromoCodeCollectionsQuery } from "../../generated/graphql";

const PROMO_CODES_TABLE_HEADER = ["Дата створення", "Діє до", "Назва набору", "Опис", "Отримувач", "Файл з промокодами"];

const ROWS_PER_PAGE_OPTIONS = [10, 20];

export const PromoCodes = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [editId, setEditId] = useState<string | null>(null);

  const { data, refetch } = useGetPromoCodeCollectionsQuery({
    variables: {
      input: {
        limit: rowsPerPage,
        skip: page * rowsPerPage,
      },
    },
  });

  const items = data?.getPromoCodeCollections?.items ?? [];
  const total = data?.getPromoCodeCollections?.total ?? 0;

  const handleChangePage = (_: React.MouseEvent<HTMLButtonElement, MouseEvent>, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleCloseModal = () => setEditId(null);

  const handleSuccess = async () => {
    await refetch();
    handleCloseModal();
  };

  return (
    <Container maxWidth="lg">
      <Header>Промокоди</Header>

      <Box
        display="flex"
        justifyContent="flex-end"
      >
        <ButtonPlus
          width={240}
          variant="contained"
          noPlus
          onClick={() => setEditId("")}
        >
          Додати набір промокодів
        </ButtonPlus>
      </Box>

      <Table>
        <div>
          <PromoCodesHeaderRow>
            <PromoCodesHeadTableCell />
            {PROMO_CODES_TABLE_HEADER.map((el) => (
              <PromoCodesHeadTableCell key={el}>{el}</PromoCodesHeadTableCell>
            ))}
          </PromoCodesHeaderRow>
        </div>

        <div>
          {items.map((item) => item && (
            <PromoCode key={item.id} {...item} onEdit={setEditId} />
          ))}
        </div>
      </Table>

      {total > 0 ? (
        <CustomTablePagination
          rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
          count={total}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      ) : null}

      {editId !== null && (
        <PromoCodesModal
          id={editId || null}
          onClose={handleCloseModal}
          onSuccess={handleSuccess}
        />
      )}
    </Container>
  );
};